import { getWasserman9GraphsData } from "../api/wasserman9";
import { GraphSystems, GraphType } from "../types";
import useGraphsFactory from "./useGraphsFactory";

export default function useWasserman9Data({
    systemId,
    testId,
    enabled = true,
}: {
    systemId?: GraphSystems;
    testId?: string;
    enabled?: boolean;
}) {
    // Create a unique key for the SWR cache
    const swrKey =
        testId && enabled
            ? `graphs:wasserman-9-${JSON.stringify({
                  testId,
                  systemId,
              })}`
            : null;

    const fetcher = async () => {
        if (!testId) {
            throw new Error("Test ID is required");
        }

        return await getWasserman9GraphsData({
            testId,
            systemId,
        });
    };

    const graphsType: GraphType = "wasserman-9";

    return {
        ...useGraphsFactory(fetcher, swrKey, { keepUnsavedChanges: true }),
        graphsType,
    };
}
